/**
 * @generated SignedSource<<aa333fd4b60c894bf357d6e714fcc2b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceProductsSearchQuery$variables = {
  query: string;
  workspaceId: string;
};
export type WorkspaceProductsSearchQuery$data = {
  readonly workspace: {
    readonly productSearch: {
      readonly hits: ReadonlyArray<{
        readonly id: string | null;
        readonly product: {
          readonly id: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceProductSearchItem_workspaceProductSearchHit">;
      }>;
    };
  };
};
export type WorkspaceProductsSearchQuery = {
  response: WorkspaceProductsSearchQuery$data;
  variables: WorkspaceProductsSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceProductsSearchQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Workspace",
          "kind": "LinkedField",
          "name": "workspace",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "WorkspaceProductSearchResponse",
              "kind": "LinkedField",
              "name": "productSearch",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WorkspaceProductSearchHit",
                  "kind": "LinkedField",
                  "name": "hits",
                  "plural": true,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkspaceProduct",
                      "kind": "LinkedField",
                      "name": "product",
                      "plural": false,
                      "selections": [
                        (v4/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "WorkspaceProductSearchItem_workspaceProductSearchHit"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceProductsSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "WorkspaceProductSearchResponse",
            "kind": "LinkedField",
            "name": "productSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceProductSearchHit",
                "kind": "LinkedField",
                "name": "hits",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkspaceProduct",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "partNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkspaceProductSearchHitHighlightPart",
                    "kind": "LinkedField",
                    "name": "nameHighlights",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isHighlighted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec87d6e5d796e04c7b2bcccc4f2c88f1",
    "id": null,
    "metadata": {},
    "name": "WorkspaceProductsSearchQuery",
    "operationKind": "query",
    "text": "query WorkspaceProductsSearchQuery(\n  $workspaceId: ID!\n  $query: String!\n) {\n  workspace(id: $workspaceId) {\n    productSearch(query: $query) {\n      hits {\n        id\n        product {\n          id\n        }\n        ...WorkspaceProductSearchItem_workspaceProductSearchHit\n      }\n    }\n    id\n  }\n}\n\nfragment WorkspaceProductSearchItem_workspaceProductSearchHit on WorkspaceProductSearchHit {\n  id\n  nameHighlights {\n    isHighlighted\n    text\n  }\n  product {\n    id\n    imageUrl\n    partNumber\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ce7008b0f5c7de5d7ded876b7935181";

export default node;
